import { loadSubscriptionModal } from "@components/modal/subscriptionProposal";
import { jrSessionStorage, JrSessionStorageKeys } from "@utils/storage";

const onMouseOut = (e: MouseEvent) => {
  const shouldShowExitIntentPopup = !e.relatedTarget && e.clientY < 10;
  if (shouldShowExitIntentPopup) {
    document.removeEventListener('mouseout', onMouseOut);
    jrSessionStorage.setItem(JrSessionStorageKeys.EXIT_INTENT_POPUP_WAS_DISPLAYED, true);
    loadSubscriptionModal('exit_intent');
  }
};

export const activateExitIntentPopup = (): void => {
  if (!jrSessionStorage.getItem(JrSessionStorageKeys.EXIT_INTENT_POPUP_WAS_DISPLAYED)) {
    document.addEventListener('mouseout', onMouseOut);
  }
}
